export default "__VITE_ASSET__BAqmry6i__"